import styled from "styled-components";

// Estilos Reutilizáveis (Nosso "Design System")
export const ConsultoresContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  padding: 40px;
  box-sizing: border-box;
  background-image: url("/textura.jpg");
  background-size: cover;
  background-attachment: fixed;
`;

export const ContentBox = styled.div`
  background: rgba(30, 30, 30, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 30px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.37);
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  gap: 20px; /* Adiciona um espaço entre o botão de admin e o resto */

  h2 {
    margin: 0;
    color: #e6aa3a;
    font-size: 28px;
  }
`;

// Novo container para alinhar os itens à direita do header
export const HeaderRightContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;

export const ActionButton = styled.button`
  background: #e6aa3a;
  color: #111;
  border: none;
  border-radius: 6px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: #ffc300;
    transform: translateY(-2px);
    box-shadow: 0 4px 15px rgba(230, 170, 58, 0.4);
  }

  &:disabled {
    background: #a08144;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

// Novo estilo para o botão de login do admin
export const AdminLoginButton = styled(ActionButton)`
  background: #333; // Cor diferente para destacar que é uma ação secundária/diferente
  color: #fff;
  border: 1px solid #555;

  &:hover {
    background: #444;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  }

  &:disabled {
    background: #222;
    color: #777;
  }
`;

// Estilos Específicos da Página
export const Title = styled.h2`
  margin: 0;
  color: #e6aa3a;
  font-size: 28px;
  white-space: nowrap; /* Evita que o título quebre linha */
`;

export const CreateButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
`;

export const FilterArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const SearchBar = styled.div`
  display: flex;
  flex-grow: 1;

  input {
    width: 100%;
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 20px;
    color: #fff;
    border-radius: 6px 0 0 6px;
    font-size: 16px;

    &::placeholder {
      color: rgba(255, 255, 255, 0.5);
    }
    &:focus {
      outline: none;
      border-color: #e6aa3a;
    }
  }

  button {
    width: 60px;
    height: 45px;
    border: none;
    background: #e6aa3a;
    color: #111;
    cursor: pointer;
    border-radius: 0 6px 6px 0;
    font-size: 18px;
    transition: background 0.3s;

    &:hover {
      background: #ffc300;
    }
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #fff;

  select {
    height: 45px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    background: rgba(0, 0, 0, 0.3);
    padding: 0 15px;
    color: #fff;
    border-radius: 6px;
  }
`;

export const ConsultoresTableContainer = styled(ContentBox)``; // Reutilizando o estilo base
export const ConsultoresTable = styled.div``; // Não precisamos mais deste container extra

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 15px;
    text-align: left;
    white-space: nowrap;
  }

  thead tr {
    background-color: rgba(0, 0, 0, 0.2);
    border-bottom: 2px solid #e6aa3a;
    th {
      color: #fff;
      font-weight: 600;
    }
  }

  tbody tr {
    color: rgba(255, 255, 255, 0.9);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    transition: background-color 0.3s;
    cursor: pointer;

    &:hover {
      background-color: rgba(230, 170, 58, 0.1);
    }
  }
`;

export const TableHeader = styled.thead``;
export const TableRow = styled.tr``;
export const TableHeaderCell = styled.th``;
export const TableBody = styled.tbody``;
export const TableCell = styled.td``;
